import BillingAddress from './pages/BillingAddress'
import ShippingAddress from './pages/ShippingAddress'
import SoftwareSelection from './pages/SoftwareSelection'
import BookSelection from './pages/BookSelection'
import ContactForm from './pages/ContactForm'
import TermsAndConditions from './pages/TermsAndConditions'
import Payment from './pages/Payment'


const ROUTES = [
  { path: '/contact',    name: 'Contact',    content: ContactForm,         data: 'contact'         },
  { path: '/address',    name: 'Address',    content: BillingAddress,      data: 'billingAddress'  },
  { path: '/shipping',   name: 'Shipping',   content: ShippingAddress,     data: 'shippingAddress' },
  { path: '/software',   name: 'Software',   content: SoftwareSelection,   data: 'software'        },
  { path: '/books',      name: 'Books',      content: BookSelection,       data: 'orders'          },
  { path: '/terms',      name: 'Terms',      content: TermsAndConditions,  data: 'terms'           },
  { path: '/order',      name: 'Pay',        content: Payment,             data: 'credit'          },
]

let hiddenPaths = {}


var routes = {}


routes.get = (i) => {
  return routes.all()[i]
}


routes.all = () => {
  return ROUTES.filter(r => !hiddenPaths[r.path])
}


routes.removePath = (path) => {
  hiddenPaths[path] = true
}


routes.restorePath = (path) => {
  hiddenPaths[path] = false
}


routes.length = () => {
  return routes.all().length
}


routes.indexForPath = (path) => {
  const allRoutes = routes.all()
  for (let i = 0; i < allRoutes.length; i++) {
    if (allRoutes[i].path === path) return i
  }
  return -1
}


export default routes
